// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Mla9","addWidgetButton":"Header_addWidgetButton__1YU9N","dashboardTabs":"Header_dashboardTabs__2SmR1","active":"Header_active__2jtnp"};